import React from "react";
import PropTypes from "prop-types";
import { Box, CircularProgress } from "@mui/material";
import { useDispatch } from "react-redux";
import { WalletBtns, WalletContainer, WalletHeader, WalletInputField } from "../auth/wallet/walletStyles";
import { toggleActivateWalletModal } from "../redux/WalletSlice";

const ConfirmWithOtp = ({ otp, handleChange, isBtnDisabled, onProceed, onGetOtpClick, isLoading }) => {
	const dispatch = useDispatch();

	const onCloseModal = () => {
		dispatch(toggleActivateWalletModal(false));
	};

	const isGetOtpBtnDisabled = () => {
		if (isLoading || !isBtnDisabled) {
			return true;
		} else {
			return false;
		}
	};

	console.log(isBtnDisabled);

	return (
		<WalletContainer>
			<>
				<WalletHeader
					headerText='Verify Account'
					onCloseModal={onCloseModal}
					context='You need to verify with your registered email'
				/>
				<Box sx={{ marginTop: 2 }} display='flex' flexDirection='column' gap={1}>
					<label htmlFor='otp'>
						Click on the <span style={{ fontWeight: 500 }}>Get OTP</span> button to send get verification
						code.
					</label>
					{!isBtnDisabled && <p style={{ color: "green" }}>Otp Verification Successful.</p>}
					<Box sx={{ position: "relative" }}>
						<WalletInputField
							name='otp'
							value={otp}
							onChange={handleChange}
							placeholder='Enter OTP'
							maxLength={6}
							style={{ width: "100%" }}
							disabled={!isBtnDisabled}
						/>
						{isBtnDisabled && (
							<button className='get-otp-btn' onClick={onGetOtpClick} disabled={isGetOtpBtnDisabled()}>
								{isLoading ? (
									<CircularProgress color='primary' size={30} thickness={5} />
								) : (
									<span style={{ color: isGetOtpBtnDisabled() ? "#AABDC5" : "#003A50" }}>Get OTP</span>
								)}
							</button>
						)}
					</Box>
				</Box>
				<WalletBtns
					greenBtnClick={onProceed}
					hideWhiteBtn
					btnText='proceed'
					isGreenBtnDisabled={isBtnDisabled}
					isLoading={!isBtnDisabled && isLoading}
				/>
			</>
		</WalletContainer>
	);
};

export default ConfirmWithOtp;

ConfirmWithOtp.propTypes = {
	onProceed: PropTypes.func,
	handleChange: PropTypes.func,
	onGetOtpClick: PropTypes.func,
	otp: PropTypes.string,
	isBtnDisabled: PropTypes.bool,
	isLoading: PropTypes.bool,
};
